import { SET_AUTH, PURGE_AUTH } from "../mutations.type";
import JwtService from "@/common/jwt.service.js";

export const state = {};

const mutations = {
  [SET_AUTH](state, user) {
    JwtService.saveToken(user.token);
    JwtService.saveUsername(user.username);
    JwtService.saveRole(user.role);
    JwtService.saveName(user.name);
  },
  [PURGE_AUTH]() {
    JwtService.destroyToken();
    JwtService.destroyUsername();
    JwtService.destroyName();
    JwtService.destroyRole();
  },
};

const getters = {};

export default {
  state,
  mutations,
  getters,
};
